const publicPaths = {
  login: '/login',
  home: '/home',
  policy: '/policy'
};

const protectedPaths = {
  all: '/*',
  orderList: '/order-list',
  orderCsv: '/order-csv',
  productList: '/product-list',
  customerList: '/customer-list',
  customerProductList: '/customer-product-list',
  customerShipList: '/customer-ship-list',
  deliveryList: '/delivery-list',
  calendarSetting: '/calendar-setting',
};

export const routingPath = {
  ...publicPaths,
  ...protectedPaths,
  admin: Object.fromEntries(
    Object.entries(protectedPaths).map(([key, path]) => [key, `/admin${path}`])
  ),
  all: '*',
};
